export const GRADIENT_GREEN_1 = 'gradient-green-1'
export const GRADIENT_BLUE_1 = 'gradient-blue-1'
export const GRADIENT_ORANGE_1 = 'gradient-orange-1'
export const GRADIENT_RED_1 = 'gradient-red-1'
export const PLAYFUL_PRODUCTS = 'playful-products'
export const WELLNESS_FEATURE = 'wellness-feature'

// Background colors
export const BG_WHITE_TG = 'bg-white-tg'
export const BG_GREY_TG = 'bg-grey-tg'
export const BG_BLACK_TG = 'bg-black-tg'

// ProfloU gradient
export const GRADIENT_RED_PF_DEVICE = 'gradient-red-pf-device'